import { supabase } from "@/integrations/supabase/client";

type CheckoutIntent =
  | { type: "pro"; returnTo: string }
  | { type: "parlay"; parlayId: string; returnTo: string };

const CHECKOUT_INTENT_KEY = "checkout_intent";

function getSafeReturnTo(pathname?: string) {
  if (!pathname || !pathname.startsWith("/")) return "/pricing";
  return pathname;
}

function redirectToAuth(intent: CheckoutIntent) {
  localStorage.setItem(CHECKOUT_INTENT_KEY, JSON.stringify(intent));
  const params = new URLSearchParams();
  params.set("returnTo", intent.returnTo);
  params.set("checkoutIntent", intent.type);
  if (intent.type === "parlay") params.set("parlayId", intent.parlayId);
  window.location.href = `/auth?${params.toString()}`;
}

async function requireAuth(intent: CheckoutIntent) {
  const { data } = await supabase.auth.getSession();
  if (!data.session?.user) {
    redirectToAuth(intent);
    return false;
  }
  return true;
}

export function readCheckoutIntent(): CheckoutIntent | null {
  const raw = localStorage.getItem(CHECKOUT_INTENT_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as CheckoutIntent;
    if (parsed.type === "pro") return { type: "pro", returnTo: getSafeReturnTo(parsed.returnTo) };
    if (parsed.type === "parlay" && parsed.parlayId) {
      return { type: "parlay", parlayId: parsed.parlayId, returnTo: getSafeReturnTo(parsed.returnTo) };
    }
  } catch {
    // noop
  }
  localStorage.removeItem(CHECKOUT_INTENT_KEY);
  return null;
}

export function clearCheckoutIntent() {
  localStorage.removeItem(CHECKOUT_INTENT_KEY);
}

export async function startCheckout() {
  const returnTo = getSafeReturnTo(window.location.pathname + window.location.search);
  const authed = await requireAuth({ type: "pro", returnTo });
  if (!authed) return;
  const w = window.open("about:blank", "_blank");
  const { data, error } = await supabase.functions.invoke("create_checkout_session", { body: {} });
  if (error) {
    w?.close();
    throw error;
  }
  const url = data?.url as string | undefined;
  if (!url) {
    w?.close();
    throw new Error("Checkout URL missing");
  }
  if (w) {
    w.location.href = url;
  } else {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}

export async function startParlayCheckout(parlayId: string) {
  const returnTo = getSafeReturnTo(window.location.pathname + window.location.search);
  const authed = await requireAuth({ type: "parlay", parlayId, returnTo });
  if (!authed) return;
  const w = window.open("about:blank", "_blank");
  const { data, error } = await supabase.functions.invoke("create_parlay_checkout_session", { body: { parlay_id: parlayId } });
  if (error) {
    w?.close();
    throw error;
  }
  if (data?.alreadyUnlocked) {
    w?.close();
    window.location.reload();
    return;
  }
  const url = data?.url as string | undefined;
  if (!url) {
    w?.close();
    throw new Error("Checkout URL missing");
  }
  if (w) {
    w.location.href = url;
  } else {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
export async function openCustomerPortal(){ const w=window.open("about:blank","_blank"); const {data,error}=await supabase.functions.invoke("create_customer_portal_session",{body:{}}); if(error){ w?.close(); throw error; } const url=data?.url as string|undefined; if(!url){ w?.close(); throw new Error("Portal URL missing"); } if(w){ w.location.href=url; } else { window.open(url,"_blank","noopener,noreferrer"); } }
